// @file Entrypoint for Lti app
import { ww } from '@@/bits/global'
import { setupVueApp } from '@@/bits/vue'
import { useLtiStore } from '@@/pinia/lti_store'
import LtiApp from '@@/vuecomponents/LtiApp.vue'

void setupVueApp({
  el: '#lti_app',
  rootComponent: LtiApp,
  usePinia: true,
  initializePiniaStore() {
    useLtiStore().initialize(ww.vueStartingState)
  },
})
